export default __webpack_public_path__ + "static/media/tfp-bottle.9e61a210.png";